var map = {
	"./ca.json": 8109,
	"./en.json": 4174,
	"./es.json": 6725,
	"./eu.json": 6727,
	"./gl.json": 4346,
	"./primevue/ca.json": 5117,
	"./primevue/es.json": 7381,
	"./primevue/eu.json": 7383,
	"./primevue/gl.json": 5002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1898;